// Constants extracted from PlatformModule.js

import React from "react";

// Constants
export const NAME = "teacher";
export const SET_ORGANIZATION_CURRICULUM_PROGRAMS =
  "SET_ORGANIZATION_CURRICULUM_PROGRAMS" + " " + NAME;
export const SET_ORGANIZATION_PLANNER_ELEMENT_SETS =
  "SET_ORGANIZATION_PLANNER_ELEMENT_SETS" + " " + NAME;
export const SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS =
  "SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS" + " " + NAME;
export const SET_CURRENT_CURRICULUM_PROGRAM =
  "SET_CURRENT_CURRICULUM_PROGRAM" + " " + NAME;
export const SET_CURRENT_PLANNER_ELEMENT_SETS =
  "SET_CURRENT_PLANNER_ELEMENT_SETS" + " " + NAME;
export const SET_ACADEMIC_YEAR_SELECTED =
  "SET_ACADEMIC_YEAR_SELECTED" + " " + NAME;
export const SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM =
  "SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM" + " " + NAME;
export const SET_SAMPLE_ORG_PORTAL_TYPE =
  "SET_SAMPLE_ORG_PORTAL_TYPE" + " " + NAME;
export const SET_DEMO_ORG_CURRICULUM_ID =
  "SET_DEMO_ORG_CURRICULUM_ID" + " " + NAME;
export const SET_ORGANIZATION_SUBJECT_LEVEL_TAGS =
  "SET_ORGANIZATION_SUBJECT_LEVEL_TAGS" + " " + NAME;
export const SET_CURRICULUM_SUBJECT_LEVEL_TAGS =
  "SET_CURRICULUM_SUBJECT_LEVEL_TAGS" + " " + NAME;
export const SET_DEFAULT_NAME_SORT_PREFERENCE =
  "SET_DEFAULT_NAME_SORT_PREFERENCE" + " " + NAME;
export const SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE =
  "SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE" + " " + NAME;
export const SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE =
  "SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE" + " " + NAME;
export const SET_FULLSCREEN_LOADING = "SET_FULLSCREEN_LOADING" + " " + NAME;
export const SET_UBD_ASSESSMENT_TYPES = "SET_UBD_ASSESSMENT_TYPES" + " " + NAME;
export const SET_AI_MODULE_MARKETING_KEY =
  "SET_AI_MODULE_MARKETING_KEY" + " " + NAME;
export const SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB =
  "SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB" + " " + NAME;

export const HOME_PAGE_WIDGET_PREFERENCES = "HOME_PAGE_WIDGET_PREFERENCES";
export const SET_TODDLE_LIBRARY_VISIBILITY =
  "SET_TODDLE_LIBRARY_VISIBILITY" + " " + NAME;

export const SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS =
  "SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS" + " " + NAME;

export const SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS =
  "SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS" + " " + NAME;

export const SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS =
  "SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS" + " " + NAME;

export const SET_LEARNING_COURSE_ENABLED =
  "SET_LEARNING_COURSE_ENABLED" + " " + NAME;

export const SET_CUSTOM_ICONS = "SET_CUSTOM_ICONS" + " " + NAME;

export const ADD_PROCESSED_CUSTOM_ICON =
  "ADD_PROCESSED_CUSTOM_ICON" + " " + NAME;

export const CONTEXTUAL_HELP_SIDEBAR_TOGGLE =
  "CONTEXTUAL_HELP_SIDEBAR_TOGGLE" + " " + NAME;

export const SET_CONTEXTUAL_HELP_SEARCH_TEXT =
  "SET_CONTEXTUAL_HELP_SEARCH_TEXT" + " " + NAME;

export const SET_CONTEXTUAL_HELP_SELECTED_OPTION =
  "SET_CONTEXTUAL_HELP_SELECTED_OPTION" + " " + NAME;

export const RESET_CONTEXTUAL_HELP_SELECTED_OPTION =
  "RESET_CONTEXTUAL_HELP_SELECTED_OPTION" + " " + NAME;
